"use client";

import { faSlidersH } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useBackToTopContext } from "~/app/[lang]/overlay/BackToTopContext";

export function FilterButton({ title }: { title: string }) {
	const { show } = useBackToTopContext();

	const filterElement =
		typeof document !== "undefined" ? document.getElementById("filter-button") : null;

	if (!(filterElement && show)) return null;

	return (
		<button
			type="button"
			className="flex items-center justify-center rounded-full bg-primary-medium p-4 text-white leading-none shadow hover:bg-primary-dark focus-visible:bg-primary-dark active:bg-primary-dark motion-safe:transition sm:px-6"
			onClick={() => filterElement.click()}
		>
			<span className="flex aspect-square items-center justify-center sm:text-lg">
				<FontAwesomeIcon icon={faSlidersH} fixedWidth />
			</span>

			<span className="ml-2 hidden sm:inline">{title}</span>
		</button>
	);
}
